<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12 sm10 md7 lg5>
        <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
        <v-card class="elevation-1" v-else>
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Update Agency</v-toolbar-title>
          </v-toolbar>
              <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="e1 > 1">Account Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="e1 > 2">Location</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Company Details</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container fluid>
            <v-layout row>
              <v-flex>
                <v-text-field
                label="First Name"
                v-model="agency.user.first_name"
                required
              ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                label="Last Name"
                v-model="agency.user.last_name"
                required
              ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                label="E-mail"
                v-model="agency.user.email"
                required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  name="input-8-1"
                  label="Enter new password"
                  v-model="agency.user.password"
                  min="8"
                  :rules="rules.passwordRules"
                  :append-icon="visibility ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (visibility = !visibility)"
                  :type="visibility ? 'password' : 'text'"
                  counter
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  name="input-8-1"
                  label="Confirm new password"
                  v-model="confirmPassword"
                  min="8"
                  :rules="rules.passwordRulesConfirm"
                  :append-icon="visibilityConfirm ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (visibilityConfirm = !visibilityConfirm)"
                  :type="visibilityConfirm ? 'password' : 'text'"
                  counter
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-btn color="primary" @click.native="e1 = 2" :disabled="!valid">Continue</v-btn>
          <v-btn color="warning" @click.native="post" :disabled="!valid">Update</v-btn>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-container fluid>
            <v-layout row>
              <v-flex>
                <v-select
                  v-bind:items="states"
                  v-model="agency.user.country"
                  label="Country"
                  class="input-group"
                  item-value="text"
                  autocomplete
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
              <v-text-field
                label="City"
                v-model="agency.user.city"
                required
              ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
              <v-text-field
                label="Address"
                v-model="agency.user.address"
                required
              ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  label="Zip Code"
                  v-model="agency.user.zip_code"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-flex>
            <v-btn color="primary" @click.native="e1 = 3">Continue</v-btn>
            <v-btn color="warning" @click.native="post">Update</v-btn>
            <v-btn flat @click.native="e1 = 1">Back</v-btn>
          </v-flex>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-container fluid>
            <v-layout row>
              <v-flex>
                <v-text-field
                label="Company"
                v-model="agency.user.company"
                required
              ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
              <img :src="imageUrl || agency.user.logo_url" height="150" v-if="imageUrl || agency.user.logo_url" />
              <v-btn
                  small
                  color="info"
                  class="white--text"
                  @click.native="pickFile"
                  v-if="!selectedFile"
                >
                  Select Logo
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/*"
                v-if="!selectedFile"
                @change="onFileSelected"
              >
                <v-btn
                  small
                  v-if="imageUrl"
                  color="primary"
                  class="white--text"
                  @click.native="sendLogo"
                >
                  Update logo
                  <v-icon right dark>cloud_upload</v-icon>
                </v-btn>
                <v-btn
                  small
                  v-if="imageUrl"
                  color="error"
                  class="white--text"
                  @click.native="resetImage"
                >
                  Cancel
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  label="Phone"
                  v-model="agency.user.phone"
                  :rules="rules.phoneValidation"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-text-field
                  label="Website"
                  v-model="agency.user.website"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-btn color="warning" @click.native="post">Update</v-btn>
          <v-btn flat @click.native="e1 = 2">Back</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
        </v-card>
      </v-flex>
          <div row>
            <v-flex>
              <v-alert
                :color="alert.type"
                icon="check_circle"
                :value="alert.status"
                transition="scale-transition"
              >
                {{ alert.message }}
              </v-alert>
            </v-flex>
          </div>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import { countryCodesSingle } from "../../../helpers/countryCodes.js";
export default {
  components: {
    Spinner
  },
  data() {
    return {
      imageName: "",
      imageUrl: "",
      selectedFile: "",
      confirmPassword: "",
      visibility: true,
      visibilityConfirm: true,
      valid: true,
      agency: {
        user: {
          password: null
        }
      },
      rules: {
        fieldRules: [v => !!v || "Field is required"],
        phoneValidation: [v => /^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."],
        passwordRules: [
          v => (v.length >= 8 || !v) || "Password must be at least 8 characters"
        ],
        passwordRulesConfirm: [
          v => (v == this.agency.user.password || !v) || "Password not confirmed",
          v => (v.length >= 8 || !v) || "Password must be at least 8 characters"
        ],
        emailRules: [
          v =>
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "E-mail must be valid"
        ]
      },
      e1: 0,
      dataLoading: true,
      alert: {
        status: false,
        message: "",
        type: ""
      },
      states: countryCodesSingle
    };
  },
  mounted: function() {
    this.getAgency();
  },
  watch: {
    "agency.user.password": function (val) {
      this.confirmPassword = '';
      if (val && val !== this.confirmPassword) {
        this.valid = false
      } else if (!val && !this.agency.user.confirmPassword) {
        this.valid = true
      } else if (val && this.agency.user.password === val){ 
        this.valid = true
      } else {
        return false
      }
    },
    confirmPassword: function (val) {
      if (val !== "" && val === this.agency.user.password) {
        this.valid = true
      } else if (!val && !this.agency.user.password) {
        this.valid = true
      } else {
        this.valid = false
      } 
    }
  },
  methods: {
    resetImage() {
      let fr = new FileReader();
      this.imageName = "";
      this.selectedFile = "";
      this.imageUrl = "";
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFileSelected(event) {
      const files = event.target.files[0];
      this.selectedFile = Object.assign(files);

      let fr = new FileReader();
      fr.readAsDataURL(files);
      fr.addEventListener("load", () => {
        this.imageUrl = fr.result;
      });
    },
    sendLogo() {
      const fd = new FormData();
      fd.append("image", this.selectedFile);
      axios
        .post("/upload", fd)
        .then(res => {
          this.agency.user.logo_url = res.data.url;
          this.post(true);
          this.resetImage();
        })
        .catch(error => {
          if (error.response.data.errors[0].detail === "validation.dimensions") {
            this.alert.message = "Logo dimension should not be bigger than 500x500 px"  
          } else {
            this.alert.message = "Logo size should not exceed 2mb"
          }
          this.alert.type = "error";
          this.alerting();
        });
    },
    goBack() {
      this.$router.push("/agency/agencies");
    },
    getAgency() {
      axios.get("/users/" + this.$route.params.id).then(res => {
        this.agency.user = res.data.user;
        this.dataLoading = "false";
      });
    },
    alerting() {
      this.alert.status = !this.alert.status;
      setTimeout(() => {
        this.alert.status = !this.alert.status;
      }, 2500);
    },
    post(isImage = false) {
      axios.put("/users/" + this.$route.params.id, this.agency).then(res => {
        this.alert.message = isImage === true ? "Logo has been changed." : "Agency has been updated.";
        this.alert.type = "success";
        this.alerting();
      });
    }
  }
};
</script>

<style>
.input-group {
  color: #28AFAF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/agency/Agencies/AgenciesEdit.vue